module.exports = __webpack_public_path__ + "resources/img/main01.f2809fc5c7bd6ecad37a020ea2040cb9.png";